import validation from 'sb-validate-js/validate.js';
import {translation} from 'utilsHelper.js';
import {substractYears} from 'datesHelper.js'
import _range from 'lodash/range';
import _repeat from 'lodash/repeat';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';

validation.validators.isAdult = function (value, {message, latest}) {
    if (!value) return null;
    const adult = value <= latest;
    return !adult ? message() : null;
};

export default {

     REGISTER_STEP1: {
        firstName: {
            presence: {
                message: () => translation('account_registerForm_firstNameEmpty'),
            },
            format: {
                pattern: /^[\w-]*$/,
                message: () => translation('account_registerForm_wrongLoginPattern'),
            },
        },
        lastName: {
            presence: {
                message: () => translation('account_registerForm_loginNameEmpty'),
                message: () => translation('account_registerForm_lastNameEmpty'),
            },
        },
        password: {
            length: {
                minimum: 8,
                maximum: 25,
                tooShort: () => translation('account_registerForm_passwordTooShort'),
                tooLong: () => translation('account_registerForm_passwordTooLong'),
            },
            format: {
                pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).*$/,
                message: () => translation('account_registerForm_wrongPasswordPattern'),
            },
            presence: {
                message: () => translation('account_registerForm_passwordEmpty'),
            },
        },
        confirmPassword: {
            presence: {
                message: () => translation('account_registerForm_passwordEmpty'),
            },
            equality: {
                attribute: 'password',
                message: () => translation('account_registerForm_passwordsNotEqual'),
            }
        },
        email: {
            presence: {
                message: () => translation('account_registerForm_emailEmpty'),
            },
            email: {
                message: () => translation('account_registerForm_wrongEmailPattern'),
            },
        },
        mobile: {
            presence: {
                message: () => translation('account_registerForm_phoneEmpty'),
            },
           format: {
                pattern: /^[1-9][0-9]{8}$/,
                message: () => translation('account_registerForm_wrongPhoneNumberPattern'),
               message: () => translation('account_registerForm_wrongPhoneNumberPattern'),
            },
            length: {
                minimum: 9,
                maximum: 9,
                tooShort: () => translation('account_registerForm_phoneTooShort'),
                    tooLong: () => translation('account_registerForm_phoneTooLong'),
            },
        },
        email: {
            email : {
                message: () => translation('account_registerForm_wrongEmailPattern')
            }
        },
        acceptRules: {
            inclusion: {
                within: [true],
                message: () => translation('account_registerForm_acceptTerms'),
            },
            presence: {
                message: () => translation('account_registerForm_acceptTerms'),
            },
        },
        dateOfBirth: {
            isAdult: {
                latest: substractYears(new Date, 18),
                message: () => translation('account_registerForm_notAdult')
            }
        },
     },
     
    REGISTER_STEP2: {
        verificationCode: {
            presence: {
                message: () => translation('account_registerForm_verificationCode'),
            }
        }
    },

    SMS_CODE_TO_PROLONG_SESSION: {
        verificationCode: {
            presence: {
                message: () => translation('prolongSession_smsCodeEmpty'),
            },
            format: {
                pattern: /^[0-9]{4}$/,
                message: () => translation('prolongSession_wrongSmsCodePattern'),
            }
        }
    }
};


